import React from "react";
import { Img } from "../Img";

interface SearchInputProps {
  id: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  id, // Ensure 'id' can be passed as a prop
  ...rest
}) => {
  return (
    <div className="flex flex-row xs:gap-2 5xl:gap-5 border border-blue_gray-300 rounded-lg xs:w-[320px] xs:h-[44px] 5xl:w-[480px] 5xl:h-[55px] items-center px-5  ">
      <Img
        src="search-lg.svg"
        alt="search"
        className="xs:size-[20px] 5xl:size-[25px]"
      />
      <input
        id={id}
        className={"focus:outline-none 5xl:placeholder:text-xl"}
        placeholder="Search"
        {...rest}
      />
    </div>
  );
};

export default SearchInput;
